import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d36bd7dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tpd-content-layout" }
const _hoisted_2 = { class: "tp-dashboard-tab mb-30" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "profile-card-body" }
const _hoisted_5 = { class: "discuss-card" }
const _hoisted_6 = {
  key: 0,
  class: "discuss-card-list"
}
const _hoisted_7 = {
  key: 0,
  class: "list-group placeholder-glow"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-2\" data-v-d36bd7dd><div class=\"placeholder rounded\" style=\"height:55px;width:60px;\" data-v-d36bd7dd></div><div data-v-d36bd7dd><div class=\"placeholder rounded\" style=\"height:8px;width:70%;\" data-v-d36bd7dd></div><div class=\"d-flex gap-2 mt-1\" data-v-d36bd7dd><div class=\"placeholder rounded\" style=\"height:20px;width:100px;\" data-v-d36bd7dd></div><div class=\"placeholder rounded\" style=\"height:20px;width:100px;\" data-v-d36bd7dd></div></div></div></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-header font-w-600" }
const _hoisted_11 = { class: "list-group list-group-flush" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "me-auto d-flex align-items-center gap-2" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = ["tooltip"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sign-in" }, null, -1 /* HOISTED */))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "alert alert-warning m-0" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */))
const _hoisted_22 = {
  key: 1,
  class: "discuss-card-body"
}
const _hoisted_23 = { class: "list-group" }
const _hoisted_24 = { class: "list-group-item d-flex justify-content-between align-items-start" }
const _hoisted_25 = { class: "me-auto d-flex align-items-center gap-3" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "fw-bold" }
const _hoisted_28 = { class: "text-secondary d-flex gap-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user-graduate mr-1" }, null, -1 /* HOISTED */))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-comment-lines mr-1" }, null, -1 /* HOISTED */))
const _hoisted_31 = ["tooltip"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-times" }, null, -1 /* HOISTED */))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["id"]
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "message-content" }
const _hoisted_37 = { class: "message-info" }
const _hoisted_38 = {
  key: 2,
  class: "text-dark font-w-400 ml-1"
}
const _hoisted_39 = ["tooltip"]
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 1,
  class: "msg-status is-sent"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-double" }, null, -1 /* HOISTED */))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 2,
  class: "msg-status not-sent"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-clock" }, null, -1 /* HOISTED */))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "discuss-card-body-form" }
const _hoisted_49 = {
  key: 0,
  class: "chat-attachments"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file mr-1" }, null, -1 /* HOISTED */))
const _hoisted_51 = { class: "d-flex align-items-center gap-3" }
const _hoisted_52 = ["placeholder"]
const _hoisted_53 = { class: "form-actions" }
const _hoisted_54 = ["tooltip"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-paperclip-vertical" }, null, -1 /* HOISTED */))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-paper-plane" }, null, -1 /* HOISTED */))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = {
  class: "modal fade",
  id: "chatMembersModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_61 = { class: "modal-dialog modal-sm" }
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = { class: "modal-header" }
const _hoisted_64 = { class: "modal-title fs-5" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Close")
], -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createCommentVNode("      <h2 class=\"tp-dashboard-tab-title\" v-if=\"authData()?.batch?.title\" v-html=\"lms_website.__('Discuss',[authData()?.batch?.title])\"></h2>"),
        _createElementVNode("h2", {
          class: "tp-dashboard-tab-title",
          innerHTML: $setup.lms_website.__('Discuss')
        }, null, 8 /* PROPS */, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (!$data.active_course)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                ($data.loading_courses_list)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                  : _createCommentVNode("v-if", true),
                (!$data.loading_courses_list)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.courses_list, (batch, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["card", {'mb-3':((index+1)<$data.courses_list.length)}]),
                        key: batch.parent
                      }, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(batch.title), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(batch.courses, (course) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: course.name,
                              onClick: $event => ($options.join_group(course)),
                              class: "list-group-item list-group-item-action pointer-event d-flex justify-content-between align-items-start"
                            }, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("img", {
                                  src: (course.image)?course.image:'/assets/lms_website/images/placeholder.jpg',
                                  alt: ""
                                }, null, 8 /* PROPS */, _hoisted_14),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_15, _toDisplayString($options.clip(course.title, 100)), 1 /* TEXT */),
                                  _createCommentVNode("                    <div class=\"text-secondary d-flex gap-3\">"),
                                  _createCommentVNode("                      <div><i class=\"fal fa-user-graduate mr-1\"></i> {{ course.enrollment_count }} {{ lms_website.__('Students') }}</div>"),
                                  _createCommentVNode("                      <div><i class=\"fal fa-comment-lines mr-1\"></i> {{ course.discussion_count }} {{ lms_website.__('Messages') }}</div>"),
                                  _createCommentVNode("                    </div>")
                                ])
                              ]),
                              _createElementVNode("span", {
                                class: "discuss-join-icon",
                                tooltip: $setup.lms_website.__('Join Group')
                              }, _hoisted_18, 8 /* PROPS */, _hoisted_16)
                            ], 8 /* PROPS */, _hoisted_12))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ], 2 /* CLASS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (!$data.loading_courses_list && !$data.courses_list.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString($setup.lms_website.__('No courses found in this batch')), 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          ($data.active_course)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("img", {
                        src: ($data.active_course?.image)?$data.active_course?.image:'/assets/lms_website/images/placeholder.jpg',
                        alt: ""
                      }, null, 8 /* PROPS */, _hoisted_26),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_27, _toDisplayString($options.clip($data.active_course?.title, 75)), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", null, [
                            _hoisted_29,
                            _createTextVNode(" " + _toDisplayString($data.active_course?.enrollment_count) + " " + _toDisplayString($setup.lms_website.__('Students')), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_30,
                            _createTextVNode(" " + _toDisplayString($data.active_course?.discussion_count) + " " + _toDisplayString($setup.lms_website.__('Messages')), 1 /* TEXT */)
                          ])
                        ])
                      ])
                    ]),
                    _createCommentVNode("              <span class=\"discuss-users-icon\" @click=\"show_members(active_course?.name)\" :tooltip=\"lms_website.__('Group Members')\"><i class=\"far fa-users\"></i></span>"),
                    _createElementVNode("span", {
                      class: "discuss-close-icon",
                      onClick: _cache[0] || (_cache[0] = $event => ($options.exit_group())),
                      tooltip: $setup.lms_website.__('Close Chat')
                    }, _hoisted_33, 8 /* PROPS */, _hoisted_31)
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["discuss-card-body-chat-list", {'form-loading':$data.loading_chat_list}])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.chat_list, (msg) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: msg.name,
                      class: _normalizeClass(["message-container animate__animated animate__faster animate__zoomIn", {'sent':(msg.is_my_message),'is-instructor':($options.courseInstructor===msg.user.name)}]),
                      id: `chat-msg-${msg.name}`
                    }, [
                      (!msg.is_my_message)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: (msg.user.user_image)?msg.user.user_image:'/assets/lms_website/images/user.png',
                            class: "avatar",
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_35))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("span", null, [
                            (msg.is_my_message)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString($setup.lms_website.__('Me')), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true),
                            (!msg.is_my_message)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(msg.user.full_name), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true),
                            ($options.courseInstructor===msg.user.name)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_38, "(Instructor)"))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("span", {
                            tooltip: $setup.moment(msg.creation).format('DD MMM, hh:mm a')
                          }, _toDisplayString($setup.timeAgo(msg.creation)), 9 /* TEXT, PROPS */, _hoisted_39)
                        ]),
                        _createElementVNode("div", {
                          class: "break-word",
                          innerHTML: $options.replaceURLsWithLinks($options.nl_to_br($options.sanitizedHtml(msg.message)))
                        }, null, 8 /* PROPS */, _hoisted_40),
                        (msg.attachment)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "message-attachment",
                              innerHTML: $options.attachment_view(msg.attachment)
                            }, null, 8 /* PROPS */, _hoisted_41))
                          : _createCommentVNode("v-if", true),
                        (msg.is_sent)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, _hoisted_44))
                          : _createCommentVNode("v-if", true),
                        (!msg.is_sent)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _hoisted_47))
                          : _createCommentVNode("v-if", true)
                      ])
                    ], 10 /* CLASS, PROPS */, _hoisted_34))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 2 /* CLASS */),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("form", {
                    method: "post",
                    onSubmit: _cache[3] || (_cache[3] = $event => ($options.send_message($event)))
                  }, [
                    ($data.form.attachment && $data.form.attachment?.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("div", null, [
                            _hoisted_50,
                            _createTextVNode(),
                            _createElementVNode("span", null, _toDisplayString($data.form.attachment?.name), 1 /* TEXT */)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_51, [
                      _withDirectives(_createElementVNode("textarea", {
                        rows: "2",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.form.message) = $event)),
                        placeholder: $setup.lms_website.__('Type your message...'),
                        required: ""
                      }, null, 8 /* PROPS */, _hoisted_52), [
                        [_vModelText, $data.form.message]
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-attachment",
                          onClick: _cache[2] || (_cache[2] = $event => ($options.attach_file())),
                          tooltip: $setup.lms_website.__('Attach File')
                        }, _hoisted_56, 8 /* PROPS */, _hoisted_54),
                        _createElementVNode("button", {
                          type: "submit",
                          disabled: !$data.form.message && !$data.form.attachment,
                          class: "btn btn-primary"
                        }, _hoisted_59, 8 /* PROPS */, _hoisted_57)
                      ])
                    ])
                  ], 32 /* NEED_HYDRATION */)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("h1", _hoisted_64, _toDisplayString($setup.lms_website.__('Group Members')), 1 /* TEXT */),
              _hoisted_65
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["modal-body min-height-100", {'form-loading':($data.members.loading)}])
            }, null, 2 /* CLASS */),
            _hoisted_66
          ])
        ])
      ])
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}